module.exports = __webpack_public_path__ + "static/media/BD_website_01a_pb.d74e87a0.jpg";